export default {
  zh: {
    remove: 'Remove from Guild',
    confirmText: 'Confirm',
    cancel: 'Cancel',
    view: 'View',
    sesmsg: 'The operation was successful',
    update: 'Update',
    setAdmin: 'Set as admin',
    yousure: 'Are you sure you want to remove this host?',
    host: 'Host',
    admin: 'Admin',
    target: 'Target',
    sethost: 'Set as host',
    cantten: 'Fill in 10 digits at most.',
    leader: 'Leader'
  },
  en: {
    remove: 'Remove from Guild',
    confirmText: 'Confirm',
    cancel: 'Cancel',
    view: 'View',
    sesmsg: 'The operation was successful',
    update: 'Update',
    setAdmin: 'Set as admin',
    yousure: 'Are you sure you want to remove this host?',
    host: 'Host',
    admin: 'Admin',
    target: 'Target',
    sethost: 'Set as host',
    cantten: 'Fill in 10 digits at most.',
    leader: 'Leader',
    myInfoText: 'My Info',
    bankIdText: 'Account',
    bankNameText: 'BankName',
    payeeName: 'PayeeName',
    saveChanges: 'Save Changes'
  },
  ar: {
    // 阿拉伯
    remove: 'إزالة من الوكالة',
    confirmText: 'تأكيد',
    cancel: 'الغاء',
    view: 'عرض',
    sesmsg: 'العملية كانت ناجحه',
    update: 'تحديث',
    setAdmin: 'تعيين كأدمن',
    yousure: 'هل انت متأكد تريد حذف هذا المضيف',
    host: 'مضيف',
    admin: 'المشرف',
    target: 'التارجت',
    sethost: 'تعيين كامضيف',
    cantten: ' املأ 10 أرقام على الأكثر.',
    leader: 'زعيم',
    myInfoText: 'معلوماتي',
    bankIdText: 'اسم البنك',
    bankNameText: 'رقم الحساب',
    payeeName: 'الاسم',
    saveChanges: 'حفظ التغييرات '
  },
  tr: {
    //土耳其
    remove: 'Ajanstan Çıkar',
    confirmText: 'Onayla',
    cancel: 'İptal Et',
    view: 'Profil',
    leader: 'Lider',
    sesmsg: 'İşlem Başarılı Oldu',
    update: 'Güncelleme',
    setAdmin: 'Yönetici Olarak Ayarla',
    yousure: 'Bu Yayıncıyı çıkarmak istediğinizden emin misiniz?',
    host: 'Yayıncı',
    admin: 'Admin',
    target: 'Kota',
    sethost: 'Yayıncı Olarak Ayarla',
    cantten: 'En fazla 10 basamak doldurun.',
    myInfoText: 'Bilgilerim',
    bankIdText: 'İban',
    bankNameText: 'Banka İsmi',
    payeeName: 'İsim Soyisim',
    saveChanges: 'Değişiklikleri Kaydet'
  },
  pt: {
    remove: 'Remover do Guilda',
    confirmText: 'Confirmar',
    cancel: 'Cancelar',
    view: 'Ver',
    sesmsg: 'A operação foi bem-sucedida',
    update: 'Atualizar',
    setAdmin: 'Definir como administrador',
    yousure: 'Tem certeza de que deseja remover este anfitrião?',
    host: 'Anfitrião',
    admin: 'Administrador',
    target: 'Alvo',
    sethost: 'Definir como anfitrião',
    cantten: 'Preencha no máximo 10 dígitos.',
    leader: 'Líder',
    myInfoText: 'Minhas Informações',
    bankIdText: 'Conta',
    bankNameText: 'Nome do Banco',
    payeeName: 'Nome do Beneficiário',
    saveChanges: 'Salvar Alterações'
  },

  id: {
    remove: 'Hapus dari Guild',
    confirmText: 'Konfirmasi',
    cancel: 'Batal',
    view: 'Lihat',
    sesmsg: 'Operasi berhasil',
    update: 'Perbarui',
    setAdmin: 'Tetapkan sebagai admin',
    yousure: 'Apakah Anda yakin ingin menghapus host ini?',
    host: 'Host',
    admin: 'Admin',
    target: 'Target',
    sethost: 'Tetapkan sebagai host',
    cantten: 'Isi maksimal 10 digit.',
    leader: 'Pemimpin',
    myInfoText: 'Informasi Saya',
    bankIdText: 'Akun',
    bankNameText: 'Nama Bank',
    payeeName: 'Nama Penerima',
    saveChanges: 'Simpan Perubahan'
  },
  uz: {
    remove: 'Gildiyadan olib tashlash',
    confirmText: 'Tasdiqlash',
    cancel: 'Bekor qilish',
    view: "Ko'rish",
    sesmsg: 'Amaliyot muvaffaqiyatli bajarildi',
    update: 'Yangilash',
    setAdmin: 'Admin sifatida belgilash',
    yousure: 'Ushbu xostni olib tashlashga ishonchingiz komilmi?',
    host: 'Xost',
    admin: 'Admin',
    target: "Ma'lumot",
    sethost: 'Xost sifatida belgilash',
    cantten: "Eng ko'pi bilan 10 raqamni to'ldiring.",
    leader: 'Rahbar',
    myInfoText: "Mening Ma'lumotlarim",
    bankIdText: 'Hisob',
    bankNameText: 'Bank nomi',
    payeeName: "To'lov oluvchining ismi",
    saveChanges: "O'zgartirishlarni saqlash"
  },
  ru: {
    remove: 'Удалить из Гильдии',
    confirmText: 'Подтвердить',
    cancel: 'Отмена',
    view: 'Просмотр',
    sesmsg: 'Операция прошла успешно',
    update: 'Обновить',
    setAdmin: 'Назначить администратором',
    yousure: 'Вы уверены, что хотите удалить этого хоста?',
    host: 'Хост',
    admin: 'Администратор',
    target: 'Цель',
    sethost: 'Назначить хостом',
    cantten: 'Заполните не более 10 цифр.',
    leader: 'Лидер',
    myInfoText: 'Моя информация',
    bankIdText: 'Аккаунт',
    bankNameText: 'Название банка',
    payeeName: 'Имя получателя',
    saveChanges: 'Сохранить изменения'
  },
  fa: {
    remove: 'حذف از گیلد',
    confirmText: 'تأیید',
    cancel: 'لغو',
    view: 'مشاهده',
    sesmsg: 'عملیات با موفقیت انجام شد',
    update: 'بروزرسانی',
    setAdmin: 'تنظیم به عنوان مدیر',
    yousure: 'آیا مطمئن هستید که می‌خواهید این میزبان را حذف کنید؟',
    host: 'میزبان',
    admin: 'مدیر',
    target: 'هدف',
    sethost: 'تنظیم به عنوان میزبان',
    cantten: 'حداکثر 10 رقم را وارد کنید.',
    leader: 'رهبر',
    myInfoText: 'اطلاعات من',
    bankIdText: 'حساب',
    bankNameText: 'نام بانک',
    payeeName: 'نام دریافت‌کننده',
    saveChanges: 'ذخیره تغییرات'
  },
  ur: {
    remove: 'گلڈ سے ہٹائیں',
    confirmText: 'تصدیق کریں',
    cancel: 'منسوخ کریں',
    view: 'دیکھیں',
    sesmsg: 'عمل کامیاب رہا',
    update: 'اپ ڈیٹ کریں',
    setAdmin: 'ایڈمن بنائیں',
    yousure: 'کیا آپ واقعی اس ہوسٹ کو ہٹانا چاہتے ہیں؟',
    host: 'ہوسٹ',
    admin: 'ایڈمن',
    target: 'ٹارگٹ',
    sethost: 'ہوسٹ بنائیں',
    cantten: 'زیادہ سے زیادہ 10 ہندسے بھریں',
    leader: 'لیڈر',
    myInfoText: 'میری معلومات',
    bankIdText: 'اکاؤنٹ',
    bankNameText: 'بینک کا نام',
    payeeName: 'وصول کنندہ کا نام',
    saveChanges: 'تبدیلیاں محفوظ کریں'
  }
}



// WEBPACK FOOTER //
// src/pages/app/host-Info/lang.js